import type { ButtonType } from '@duel/button';

export interface IBrandingTokens {
	application: string;
	standardButtonStyle: ButtonType;
	sageLogo: string;
	useRecommendationsLogo: boolean;
}

const brandingTokens: IBrandingTokens = {
	application: 'ogm',
	standardButtonStyle: 'primary',
	sageLogo: '/img/sagelogo.png',
	useRecommendationsLogo: null,
};

export function setBrandingTokens(newTokens: IBrandingTokens) {
	for (const key in newTokens) {
		if (Object.prototype.hasOwnProperty.call(newTokens, key)) {
			brandingTokens[key] = newTokens[key];
		}
	}
}

export default brandingTokens;
